// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"40b581061f5b0cec71e3","655":"e03fc96c033ce3f83fc6"}[chunkId] + ".js";
};